<div class="modal-container billing-profile-modal">
    <h1 class="billing-modal-title">{{ data?.editing ? 'Billing information' : 'Complete Your Billing Information' }}</h1>
    <div>
        <p class="information-line" *ngIf="!data?.editing">Before upgrading your plan, please fill in your Billing Information in your profile.</p>
        <p class="information-line" *ngIf="!data?.editing">This ensures your purchase experience stays smooth and uninterrupted.</p>
        <p class="information-line" *ngIf="data?.editing">This address is already on your account. Change it only if your invoices should use a different one.</p>
        <form [formGroup]="form" class="billing-form" autocomplete="off">
            <mat-form-field appearance="outline">
                <mat-label>Country</mat-label>
                <mat-icon matPrefix>public</mat-icon>
                <input type="text" matInput [formControl]="countryControl" [matAutocomplete]="autoCountry"
                    required aria-label="Country" (blur)="onCountryInputBlur()">
                <mat-autocomplete #autoCountry="matAutocomplete" [displayWith]="displayCountry.bind(this)"
                    (optionSelected)="onCountrySelected($event.option.value)">
                    <mat-option *ngFor="let country of filteredCountries" [value]="country.code">
                        {{ country.name }}
                    </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="form.get('country')?.hasError('required')">
                    Country is required
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>State</mat-label>
                <mat-icon matPrefix>map</mat-icon>
                <input type="text" matInput [formControl]="stateControl" [matAutocomplete]="autoState"
                    required aria-label="State" (blur)="onStateInputBlur()">
                <mat-autocomplete #autoState="matAutocomplete" [displayWith]="displayState.bind(this)"
                    (optionSelected)="onStateSelected($event.option.value)">
                    <mat-option *ngFor="let state of filteredStates" [value]="state.code">
                        {{ state.name }}
                    </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="form.get('state')?.hasError('required')">
                    State is required
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Address Line 1</mat-label>
                <mat-icon matPrefix>home</mat-icon>
                <input matInput formControlName="address1" required aria-label="Address Line 1" autocomplete="off" />
                <mat-error *ngIf="form.get('address1')?.hasError('required')">
                    Address is required
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Address Line 2</mat-label>
                <mat-icon matPrefix>home</mat-icon>
                <input matInput formControlName="address2" aria-label="Address Line 2" autocomplete="off" />
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>City</mat-label>
                <mat-icon matPrefix>location_city</mat-icon>
                <input matInput formControlName="city" required aria-label="City" autocomplete="off" />
                <mat-error *ngIf="form.get('city')?.hasError('required')">
                    City is required
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Zip Code</mat-label>
                <mat-icon matPrefix>fiber_pin</mat-icon>
                <input matInput formControlName="zipCode" required aria-label="Zip Code" autocomplete="off" />
                <mat-error *ngIf="form.get('zipCode')?.hasError('required')">
                    Zip Code is required
                </mat-error>
            </mat-form-field>
        </form>
    </div>
    <div mat-dialog-actions align="end">
        <button mat-button (click)="onCancel()">Cancel</button>
        <button mat-flat-button color="primary" (click)="onSave()" [disabled]="!form.valid">Save & Continue</button>
    </div>
</div>